import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { ConfirmHost } from './shared/ui/ConfirmHost'
import { ToastHost } from './shared/ui/ToastHost'

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      <ConfirmHost />
      <ToastHost />
    </>
  )
}
